import {
  SubscriptionsState,
  SubscriptionKey,
  IUserMailingSetting,
} from "../type";

export function addUserToSub(
  state: SubscriptionsState,
  key: SubscriptionKey,
  user: IUserMailingSetting,
) {
  const arr = state[key];
  if (!arr.find((u) => u.userId === user.userId)) arr.push(user);
}
